import React, { ReactNode } from 'react';
import { AlignedInfo } from '@common/components';
import { FontSize } from '@common/tokens';

import { Tier } from '@institutions/graphql/queries/tiers-query';
import { tierHumanizeVisibilityOffset } from '@institutions/services';

type TierDetailsProps = {
  title: ReactNode;
  tier: Tier;
};

export function SuppliersManagementTiersDrawerTierDetails({
  title,
  tier,
}: TierDetailsProps) {
  const TierDetailsContent = [
    [
      'Staffing Request Delay',
      tierHumanizeVisibilityOffset(tier.visibilityOffset),
    ],
    ['Admin Fee', `${tier.fee}%`],
  ];

  return (
    <>
      <div className="supplier-management-tier-details__header">{title}</div>
      <AlignedInfo content={TierDetailsContent} />
      <style jsx>{`
        .supplier-management-tier-details__header {
          font-size: ${FontSize.md};
          margin-top: 24px;
          margin-bottom: 16px;
        }
      `}</style>
    </>
  );
}
